export enum Unit {
  Piece,
  Ml,
  L,
  G,
  Kg
}

export const UnitLabels: { [key: number]: string } = {
  [Unit.Piece]: "St.",
  [Unit.Ml]: "ml",
  [Unit.L]: "l",
  [Unit.G]: "g",
  [Unit.Kg]: "kg"
}

export class UnitConverter {
  public static readonly Strings: string[] = [
    "St.",
    "ml",
    "l",
    "g",
    "kg"
  ]

  static GetString(unit: Unit): string {
    return this.Strings[unit];
  }
}
